// Libraries
import { useEffect } from "react";
import { useQuery } from "@tanstack/react-query";

// Layouts
import LabeledFormInput from "@/Layouts/components/SmartAddressFormSection/LabeledFormInput";
import SmartSelector from "@/Layouts/components/InputComponents/SmartSelector";

// Types
import { TTimezone, TTimezoneResponseOK } from "./types";

// Constants
import { Z_INDEX_FOR_SELECTOR_LIST_IN_POPUP } from "@/Constants/misc";
import { TIMEZONES } from "./constants";

// API
import { requestTimezone } from "./api";

// Helpers
import { and } from "@/Common/helpers/sonar";

type TTimezoneInputProps = {
	timezone: string | undefined;
	required?: boolean;
	geoLocation: GeoLocation;
	loading: boolean;
	setTimezone: (timezone: string) => void;
};

function TimezoneInput(props: Readonly<TTimezoneInputProps>) {
	const { timezone, required = false, geoLocation, loading, setTimezone } = props;

	function hasErrors() {
		return required && !timezone;
	}

	const { data: timezoneInfo = { timeZoneId: "" }, isLoading } = useQuery({
		queryKey: ["timezoneInfo", geoLocation],
		queryFn: async () => requestTimezone(geoLocation),
		enabled: and(Boolean(geoLocation?.latitude), Boolean(geoLocation?.longitude)),
	});

	useEffect(() => {
		if ((timezoneInfo as TTimezoneResponseOK)?.timeZoneId) {
			setTimezone((timezoneInfo as TTimezoneResponseOK)?.timeZoneId);
		}
	}, [timezoneInfo]);

	return (
		<LabeledFormInput
			label="Timezone"
			formInput={
				<SmartSelector
					selectBy={"name"}
					showBy={"name"}
					options={TIMEZONES}
					selected={timezone}
					listBoxProps={{}}
					disabled={false}
					sx={{}}
					popperProps={{ sx: { zIndex: `${Z_INDEX_FOR_SELECTOR_LIST_IN_POPUP}!important` } }}
					onChangeAction={(value) => setTimezone((value as TTimezone)?.name ?? "")}
					loading={isLoading || loading}
					error={hasErrors()}
					clearable
					inputProps={{ placeholder: "Time Zone" }}
				/>
			}
		/>
	);
}

export default TimezoneInput;
